import { api } from './api';
import { canOpenInvoice, openInvoice } from './platform';

/**
 * Единый путь оплаты нативным Telegram-инвойсом для заказов, сертификатов и
 * подписок. Создаёт инвойс-ссылку, открывает шторку и по её закрытию кидает
 * window-событие 'stems:invoice-closed' ({status, orderId, orderNumber, total,
 * kind}) — его обрабатывает App.jsx: попапы, трекинг (дедуплицированный),
 * перепроверка статуса при закрытии крестом.
 *
 * Историческая причина модуля: связка жила шестью копиями (чекаут, сертификат,
 * подписка, три кнопки «Оплатить») и копии успели разъехаться поведением.
 *
 * @param {object} opts
 * @param {number} opts.id — id сущности (внутренний, не display-номер)
 * @param {'order'|'cert'|'sub'} [opts.kind]
 * @param {number|string|null} [opts.orderNumber] — display-номер (фолбэк,
 *   если бэкенд не вернул свой)
 * @param {number|null} [opts.total] — сумма для попапа/трекинга
 * @param {function} [opts.onBusy] — onBusy(true) перед сетевым запросом,
 *   onBusy(false) при закрытии шторки / фолбэке / страховочном таймауте 20с
 * @returns {Promise<boolean>} true — шторка открыта, итог придёт событием;
 *   false — инвойс недоступен (не Telegram / провайдер не подключён / ошибка),
 *   зовущий код уходит в свой redirect-фолбэк. Pending-маркеры redirect-флоу
 *   чистятся ТОЛЬКО при успешно открытой шторке — при false они остаются
 *   и работают на фолбэк.
 */
export async function payViaTgInvoice({ id, kind = 'order', orderNumber = null, total = null, onBusy }) {
  if (!canOpenInvoice()) return false;
  onBusy?.(true);
  try {
    const inv = await api.createTgInvoice(id, kind === 'order' ? undefined : kind);
    if (!inv?.invoice_link) {
      onBusy?.(false);
      return false;
    }
    const opened = openInvoice(inv.invoice_link, (status) => {
      onBusy?.(false);
      window.dispatchEvent(new CustomEvent('stems:invoice-closed', {
        detail: { status, orderId: id, orderNumber: inv.order_number || orderNumber, total, kind },
      }));
    });
    if (!opened) {
      onBusy?.(false);
      return false;
    }
    // Итог доставит invoiceClosed — маркеры redirect-флоу больше не нужны
    // (иначе грейс-механизм воскрешал попап на каждом reload)
    try {
      localStorage.removeItem('stems_pending_payment');
      localStorage.removeItem('stems_pending_payment_cert');
      if (kind === 'sub') localStorage.removeItem('stems_pending_subscription');
    } catch (e) {}
    // Страховка: если шторка зависла и callback не пришёл — снять busy
    setTimeout(() => onBusy?.(false), 20000);
    return true;
  } catch (e) {
    console.log('TG invoice unavailable, fallback to redirect:', e?.message);
    onBusy?.(false);
    return false;
  }
}
